import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import {
  getToken,
  isLoginPath,
  isNeedChangePwdActive,
  getLoginRedirectPath
} from '@/utils/auth' // 验权

router.beforeEach((to, from, next) => {
  NProgress.start()
  const token = getToken()
  const needChangePwd = token && isNeedChangePwdActive()

  if (needChangePwd && !isLoginPath(to.path)) {
    next({
      path: getLoginRedirectPath(store.getters.alias),
      query: { needChangePwd: 1 }
    })
    NProgress.done()
    return
  }

  if (token) {
    if (isLoginPath(to.path)) {
      next()
      NProgress.done()
      if (window._hmt) {
        window._hmt.push(['_trackPageview', to.fullPath])
      }
      return
    }

    if (store.getters.roles.length === 0) {
      store.dispatch('GetInfo').then(() => {
        store.getters.addRouters.forEach(function(route) {
          router.addRoute(route)
        })
        next({ ...to, replace: true })
        if (window._hmt) {
          window._hmt.push(['_trackPageview', to.fullPath])
        }
      }).catch((err) => {
        store.dispatch('FedLogOut').then(() => {
          Message.error(err || 'Verification failed, please login again')
          next({ path: getLoginRedirectPath(store.getters.alias) })
        })
      })
    } else {
      next()
      if (window._hmt) {
        window._hmt.push(['_trackPageview', to.fullPath])
      }
    }
    return
  }

  if (isLoginPath(to.path)) {
    next()
  } else {
    next(getLoginRedirectPath(store.getters.alias))
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
